/* 引数に与えられたテキストにハイフンがあるかを確認する */
export const isIncludeHyphen = (text: string | null) => {
  if (text === null) {
    return false;
  }
  return text.includes('-');
};
